import { AnyAction, Dispatch } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { AppDispatch, RootState } from '../..';
import { showFeedbackModal } from '../UserFeedbackActions';
import apis from '../../../utils/apis';
import { handleApiError } from '../utils/utils';
import { hideModal } from '../modalActions';
import { AppThunk } from '../../types';

export const FETCH_CASES_REQUEST = 'FETCH_CASES_REQUEST';
export const FETCH_CASES_SUCCESS = 'FETCH_CASES_SUCCESS';
export const FETCH_CASES_FAILURE = 'FETCH_CASES_FAILURE';
export const FETCH_CASE_REQUEST = 'FETCH_CASE_REQUEST';
export const FETCH_CASE_SUCCESS = 'FETCH_CASE_SUCCESS';
export const FETCH_CASE_FAILURE = 'FETCH_CASE_FAILURE';
export const GENERATE_DOCUMENT_REQUEST = 'GENERATE_DOCUMENT_REQUEST';
export const GENERATE_DOCUMENT_SUCCESS = 'GENERATE_DOCUMENT_SUCCESS';
export const GENERATE_DOCUMENT_FAILURE = 'GENERATE_DOCUMENT_FAILURE';
export const FETCH_MARKETPLACE_CASE_REQUEST = 'FETCH_MARKETPLACE_CASE_REQUEST';
export const FETCH_MARKETPLACE_CASE_SUCCESS = 'FETCH_MARKETPLACE_CASE_SUCCESS';
export const FETCH_MARKETPLACE_CASE_FAILURE = 'FETCH_MARKETPLACE_CASE_FAILURE';


export const fetchCasesRequest = (): AnyAction => ({
  type: FETCH_CASES_REQUEST,
});

export const fetchCasesSuccess = (cases: any[]): AnyAction => ({
  type: FETCH_CASES_SUCCESS,
  payload: cases,
});

export const fetchCasesFailure = (error: string): AnyAction => ({
  type: FETCH_CASES_FAILURE,
  payload: error,
});

export const fetchCaseRequest = (): AnyAction => ({
    type: FETCH_CASE_REQUEST,
  });
  
  export const fetchCaseSuccess = (caseData: any): AnyAction => ({
    type: FETCH_CASE_SUCCESS,
    payload: caseData,
  });
  
  export const fetchCaseFailure = (error: string): AnyAction => ({
    type: FETCH_CASE_FAILURE,
    payload: error,
  });

  export const generateDocumentRequest = (): AnyAction => ({
    type: GENERATE_DOCUMENT_REQUEST,
  });
  
  export const generateDocumentSuccess = (data: any): AnyAction => ({
    type: GENERATE_DOCUMENT_SUCCESS,
    payload: data,
  });
  
  export const generateDocumentFailure = (error: string): AnyAction => ({
    type: GENERATE_DOCUMENT_FAILURE,
    payload: error,
  });

  export const fetchMarketplaceCaseRequest = (): AnyAction => ({
    type: FETCH_MARKETPLACE_CASE_REQUEST,
  });
  
  export const fetchMarketplaceCaseSuccess = (caseData: any): AnyAction => ({
    type: FETCH_MARKETPLACE_CASE_SUCCESS,
    payload: caseData,
  });
  
  export const fetchMarketplaceCaseFailure = (error: string): AnyAction => ({
    type: FETCH_MARKETPLACE_CASE_FAILURE,
    payload: error,
  });

export const FETCH_ALL_CASES        = 'FETCH_ALL_CASES';
export const APPEND_CASES           = 'APPEND_CASES';

interface FetchCasesParams {
  searchTerm?: string;
  filters?: { [k: string]: string[] };
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  page_size?: number;
}

export const fetchCases = (params: FetchCasesParams = {}) =>
  async (dispatch: any): Promise<any> => {
    const {
      searchTerm = '',
      filters    = {},
      sortBy     = '',
      sortOrder  = 'asc',
      page       = 1,
      page_size  = 12,
    } = params;

    const filtersJson = JSON.stringify(filters);

    try {
      const resp = await apis.get('/cases/view', {
        params: { searchTerm, filters: filtersJson, sortBy, sortOrder, page, page_size }
      });

      if (resp.status === 200) {
        const { data, page: cur, total_cases } = resp.data;
        dispatch({ type: page === 1 ? FETCH_ALL_CASES : APPEND_CASES, payload: data });
        return { cases: data, currentPage: cur, total_cases };
      }
      handleApiError(resp, dispatch);
    } catch (err) {
      handleApiError(err, dispatch);
    }
    return { cases: [], currentPage: 1, total_cases: 0 };
  };


export const fetchCaseById = (caseId: string) => {
    return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
      dispatch(fetchCaseRequest());
      try {
        const response = await apis({
          method: 'POST',
          url: '/cases/get_case',
          data: { CaseID: caseId },
        });
  
        if (response && response.status === 200) {
          const caseData = response.data.case;
          dispatch(fetchCaseSuccess(caseData));
          return response.data.case;
        } else {
          handleApiError(response, dispatch);
        }
      } catch (error: any) {
        handleApiError(error, dispatch);
      }
    };
  };

  export const generateDocument = (caseId: string) => {
    return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
      dispatch(generateDocumentRequest());
  
      try {
        const response = await apis({
          method: 'POST',
          url: '/cases/generate_document',
          data: { CaseID: caseId },
        });
  
        if(response && response.status === 200){
          
          dispatch(generateDocumentSuccess(response.data));
        }else{
          handleApiError(response, dispatch);
        }
      } catch (error: any) {
        handleApiError(error, dispatch);
      }
    };
  };

  export const fetchMarketplaceCaseById = (caseId: string) => {
    return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
      dispatch(fetchMarketplaceCaseRequest());
      try {
        const response = await apis({
          method: 'POST',
          url: '/marketplace/get_case_details',
          data: { CaseID: caseId },
        });
  
        if (response && response.status === 200) {
          const caseData = response.data.case_details;
          dispatch(fetchMarketplaceCaseSuccess(caseData));
        } else {
          handleApiError(response, dispatch);
        }
      } catch (error: any) {
        handleApiError(error, dispatch);
      }
    };
  };


  export const fetchCaseSummary = (caseId: string) => {
    return async (dispatch: any) => {
      try {
        const response = await apis.post('/cases/get_case_summary', { CaseID: caseId });
        if (response && response.status === 200) {
          return response.data; 
        }else{
          handleApiError(response, dispatch);
        }
      } catch (error: any) {
        handleApiError(error, dispatch);
        return null;
      }
    };
  };
  
  export const fetchCaseCycle = (caseId: string) => {
    return async (dispatch: any) => {
      try {
        const response = await apis.post('/cases/get_case_cycle', { CaseID: caseId });
        if (response && response.status === 200) {
          return response.data; 
        }else{
          handleApiError(response, dispatch);
        }
      } catch (error: any) {
        handleApiError(error, dispatch);
        return null;
      }
    };
  };
  

  export const getCaseFinancialData = (caseId: string) => {
    return async (dispatch: any) => {
      try {
        const response = await apis.post('/cases/get_financial_data', { CaseID: caseId });
        if (response && response.status === 200) {
          return response.data.summary; 
        }else{
          handleApiError(response, dispatch);
        }
      } catch (error: any) {
        handleApiError(error, dispatch);
        return null;
      }
    };
  };

  export const editCase = (caseId: string, updatedData: any) => {
    return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
      dispatch({ type: 'EDIT_CASE_REQUEST' });
      try {
        const response = await apis({
          method: 'POST',
          url: `/cases/edit`,
          data: { CaseID: caseId, ...updatedData },
        });
  
        if (response && response.status === 200) {
          dispatch({ type: 'EDIT_CASE_SUCCESS', payload: response.data });
          dispatch(showFeedbackModal({
            showModal: true,
            message: 'Case updated successfully',
            modalType: 'success',
            duration: 3000,
          }));
          dispatch(fetchCaseSummary(caseId));
        } else {
          handleApiError(response, dispatch);
        }
      } catch (error: any) {
        handleApiError(error, dispatch);
      }
    };
  };

  export const updateCaseData = ({ caseId, operation, category, label, value, type, oldLabel }: {    
    caseId: string;
    operation: 'add' | 'edit' | 'remove';
    category: 'metadata' | 'financial_data';
    label: string;
    value?: string;
    type?: string;
    oldLabel?: string;
  }) => {
    return async (dispatch: any) => {
      dispatch({ type: 'UPDATE_CASE_DATA_REQUEST' });
      try {
        const payload = { CaseID: caseId, operation, category, label, value, type, oldLabel };
        const response = await apis({
          method: 'POST',
          url: '/cases/update_case_data',
          data: payload,
        });
  
        if (response && response.status === 200) {
          dispatch({ type: 'UPDATE_CASE_DATA_SUCCESS', payload: response.data });
          dispatch(showFeedbackModal({
            showModal: true,
            message: 'Case data updated successfully',
            modalType: 'success',
            duration: 3000,
          }));
          dispatch(fetchCaseSummary(caseId));
          dispatch(hideModal())
        } else {
          handleApiError(response, dispatch);
        }
      } catch (error) {
        handleApiError(error, dispatch);
      }
    };
  };
  
  export const deleteCase = (caseId: string) => {
    return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
      dispatch({ type: 'DELETE_CASE_REQUEST' });
      try {
        const response = await apis({
          method: 'POST',
          url: '/cases/delete',
          data: { CaseID: caseId },
        });
  
        if (response && response.status === 200) {
          const { message, client_id } = response.data;
          dispatch({
            type: 'DELETE_CASE_SUCCESS',
            payload: { case_id: caseId, client_id }
          });
          dispatch(showFeedbackModal({
            showModal: true,
            message: message || 'Case deleted successfully',
            modalType: 'success',
            duration: 3000,
          }));
          dispatch(fetchCases());
        } else {
          handleApiError(response, dispatch);
        }
      } catch (error: any) {
        handleApiError(error, dispatch);
      }
    };
  };

export const fetchUnassignedCases = (searchTerm: string = '', page: number = 1, page_size: number = 12) => {
  return async (dispatch: Dispatch) => {
    try {
      const filters = JSON.stringify({ Clients: [] }); 
      const response = await apis.get('/matters/view', {
        params: {
          filters,
          searchTerm,
          sortBy: 'created_at',
          sortOrder: 'desc',
          page,
          page_size
        }
      });

      if (response && response.status === 200) {
        return {
          matters: response.data.data,
          page: response.data.page,
          totalPages: response.data.total_pages,
          totalMatters: response.data.total_cases
        };
      } else {
        handleApiError(response, dispatch);
        return { cases: [], page: 1, totalPages: 1, totalCases: 0 };
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
      return { cases: [], page: 1, totalPages: 1, totalCases: 0 };
    }
  };
};


export const addFileToCase = (caseId: string, files: File[]) => {  
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch({ type: 'ADD_FILES_REQUEST' }); 
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('files', file); 
      });
      const response = await apis({
        method: 'POST',
        url: `/cases/${caseId}/add_file`,  
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response && response.status === 200) {
        dispatch({ type: 'ADD_FILES_SUCCESS', payload: response.data });  
        dispatch(showFeedbackModal({
          showModal: true,
          message: 'Files added successfully',
          modalType: 'success',
          duration: 3000,
        }));
        dispatch(fetchCaseSummary(caseId));
      } else {
        handleApiError(response, dispatch);
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
    }
  };
};
export const addSourceToCase = (caseId: string, sourceType: 'law' | 'case' | 'datasource', sourceData: any, file?: File) => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch({ type: 'ADD_SOURCE_REQUEST' });
    try {
      const formData = new FormData();
      formData.append('source_type', sourceType);
      formData.append('source_data', JSON.stringify(sourceData));
      if (file) {
        formData.append('file', file);
      }

      const response = await apis({
        method: 'POST',
        url: `/cases/${caseId}/add_source`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response && response.status === 200) {
        dispatch({ type: 'ADD_SOURCE_SUCCESS', payload: response.data });
        dispatch(showFeedbackModal({
          showModal: true,
          message: 'Source added successfully',
          modalType: 'success',
          duration: 3000,
        }));
        dispatch(fetchCaseSummary(caseId));
      } else {
        handleApiError(response, dispatch);
        dispatch(showFeedbackModal({
          showModal: true,
          message: 'Failed to add source. Please try again.',
          modalType: 'error',
          duration: 3000,
        }));
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
    }
  };
};

export const removeSourceFromCase = (caseId: string, sourceType: 'file' | 'law' | 'case' | 'datasource', index: number) => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    dispatch({ type: 'REMOVE_SOURCE_REQUEST' });
    try {
      const response = await apis({
        method: 'DELETE',
        url: `/cases/${caseId}/remove_source`,
        data: { source_type: sourceType, index },
      });

      if (response && response.status === 200) {
        dispatch({ type: 'REMOVE_SOURCE_SUCCESS', payload: { sourceType, index } });
        dispatch(showFeedbackModal({
          showModal: true,
          message: 'Source removed successfully',
          modalType: 'success',
          duration: 3000,
        }));
        dispatch(fetchCaseSummary(caseId));
      } else {
        handleApiError(response, dispatch);
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
    }
  };
};

export const updateCaseDescription = (caseId: string, description: string) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/update_description', {
      CaseID: caseId,
      AI_Description: description,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const AddCollaborators = (caseId: string, selectedIds: string[], roles: string[]) => {
  return async (dispatch: any) => {
    try {
      const response = await apis.post('/cases/collaborators', { CaseID: caseId, Collaborators: selectedIds, Roles: roles });
      if (response && response.status === 200) {
        dispatch(showFeedbackModal({
          showModal: true,
          message: response.data.message,
          modalType: 'success',
          duration: 3000,
        }));
        return response.data; 
      }else{
        handleApiError(response, dispatch);
      }
    } catch (error: any) {
      handleApiError(error, dispatch);
      return null;
    }
  };
};

export const updateCollaboratorRole = (caseId: string, collaboratorId: string, role: string) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/update_collaborator_role', { CaseID: caseId, CollaboratorID: collaboratorId, Role: role });
    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Role updated successfully',
        modalType: 'success',
        duration: 3000,
      }));
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const removeCollaborator = (caseId: string, collaboratorId: string) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/remove_collaborator', { CaseID: caseId, CollaboratorID: collaboratorId });
    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Access removed successfully',
        modalType: 'success',
        duration: 3000,
      }));
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const updateCaseStage = (caseId: string, stage: string) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/update_stage', { CaseID: caseId, Stage: stage });
    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Case stage updated',
        modalType: 'success',
        duration: 3000,
      }));
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const updateCaseProcesses = (caseId: string, processes: any[]) => async (dispatch: any) => {
  
  try {

    const update_processes = processes.map((process) => {
      return{
        processName: process
      }
    })
    const response = await apis.post(`/cases/update_case_process`, {CaseID: caseId,  processes: update_processes });
    if (response && response.status === 200) {
      dispatch(
        showFeedbackModal({
          showModal: true,
          message: 'Case processes updated',
          modalType: 'success',
          duration: 3000,
        })
      );
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const updateCaseProcessStatus = (
  caseId: string,
  processName: string,
  statusName: string,
) => async (dispatch: any) => {
  try {
    const payload = {
      CaseID: caseId,
      processName: processName,
      statusName: statusName,
    };

    const response = await apis.post(`/cases/update_case_process_status`, payload);

    if (response && response.status === 200) {
      dispatch(
        showFeedbackModal({
          showModal: true,
          message: 'Process status updated',
          modalType: 'success',
          duration: 3000,
        })
      );
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};
export const grantClientAccess = (caseId: string): AppThunk => async (dispatch) => {
  try {
    const response = await apis({
      method: 'POST',
      url: '/cases/grant_client_access',
      data: { CaseID: caseId },
    });
    if (response && response.status === 200) {
      dispatch(showFeedbackModal({ modalType: 'success', message: 'Client access granted', showModal: true, duration: 3000 }));
      return response.data;
    } else {
      throw new Error(response?.data?.error || 'Failed to grant client access');
    }
  } catch (error) {
    handleApiError(error, dispatch);
    throw error;
  }
};



export const submitProposal = (proposalData: {
  lawyerId: string;
  caseId: string;
  clientId: string;
  budget: number;
  timeframe: string;
  message: string;
}) => async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
  try {
    const response = await apis.post('/cases/submit_proposal', proposalData);
    if (response && response.status === 200) {
      dispatch(
        showFeedbackModal({
          showModal: true,
          message: 'Proposal submitted successfully',
          modalType: 'success',
          duration: 3000,
        })
      );
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const getProposal = (data: { caseId: string; lawyerId: string; clientId: string }) => async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
  try {
    const response = await apis.post('/cases/get_proposal', {
      CaseID: data.caseId,
      LawyerID: data.lawyerId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addQuestionnaireItem = (caseId: string, question: string) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/add_questionnaire_item', { CaseID: caseId, question });
    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Question added successfully',
        modalType: 'success',
        duration: 3000,
      }));
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const updateQuestionnaireItem = (caseId: string, index: number, updatedItem: any) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/update_questionnaire_item', { CaseID: caseId, index, updated_item: updatedItem });
    if (response && response.status === 200) {
      // dispatch(showFeedbackModal({
      //   showModal: true,
      //   message: 'Question updated successfully',
      //   modalType: 'success',
      //   duration: 3000,
      // }));
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const removeQuestionnaireItem = (caseId: string, index: number) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/remove_questionnaire_item', { CaseID: caseId, index });
    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Question removed successfully',
        modalType: 'success',
        duration: 3000,
      }));
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const finalizeQuestionnaireItem = (caseId: string, index: number, answer: string) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/finalize_questionnaire_item', { CaseID: caseId, index , answer});
    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Question finalized successfully',
        modalType: 'success',
        duration: 3000,
      }));
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const assignQuestionnaireItem = (caseId: string, index: number) => async (dispatch: any) => {
  try {
    const response = await apis.post('/cases/assign_questionnaire_item', { CaseID: caseId, index });
    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Question assigned to client successfully',
        modalType: 'success',
        duration: 3000,
      }));
      dispatch(fetchCaseSummary(caseId));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};


export const initializeCaseProgress = (steps: any[], correlation_id: string) => ({
  type: 'INITIALIZE_CASE_PROGRESS',
  payload: { steps, correlation_id},
});

export const updateCaseStepStatus = (update: { step: string, status: string, message?: string }, correlation_id: string) => ({
  type: 'UPDATE_CASE_STEP_STATUS',
  payload: {correlation_id, ...update },
});

export const clearCaseProgress = (caseId: string, correlation_id: string) => ({
  type: 'CLEAR_CASE_PROGRESS',
  payload: { correlation_id },
});

export const registerCaseCreationListeners = (
  correlationId: string,
  dispatch: AppDispatch,
  finalize?: (case_id: string, suggestedTasks: any[]) => void,
  canceled?: (case_id: string) => void
) => {
  // Socket listeners removed - legacy code
};

export const createCase = (caseData: FormData) => {
  return async (dispatch: ThunkDispatch<RootState, undefined, AnyAction>) => {
    try {
      dispatch({type: "PREPARING_CASE_DOCUMENT_AND_FETCHING_FILE_CONTENT", payload: {isPerparingDoc: true} });

      const response = await apis({
        method: 'POST',
        url: '/cases/create',
        data: caseData,
      });

      if (response && response.status === 200) {
        dispatch({type: "CONNECTING_CASE_CREATION_SERVICE", payload: {isConnecting: true, correlationId: response.data.correlation_id} });
        return response.data;
      } else {
        dispatch({type: "CASE_CREATION_FAILED", payload: response.data.error || response.data.message});
        handleApiError(response, dispatch);
      }
    } catch (error: any) {
      dispatch({type: "CASE_CREATION_FAILED", payload: error.error || error.message});
      handleApiError(error, dispatch);
    }
  }
};
